import styled from 'styled-components';
import { BlockingMessage as RawBlockingMessage } from '../../BlockingMessage';
export const Container = styled.div `
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 8;
`;
export const CenteredMobileViewContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    & .PlayPauseButton-Button {
        margin: 0 19%;
    }
    & .SeekRelativeButton-Button {
        margin-left: 0;
    }
    & .SeekRelativeButton-Icon {
        height: 42px;
        width: 32px;
    }
`;
CenteredMobileViewContainer.displayName = 'CenteredMobileViewContainer';
export const BlockingMessage = styled(RawBlockingMessage) `
    margin: 44px 0;
    font-size: 20px;
    letter-spacing: -0.17px;
`;
BlockingMessage.displayName = 'BlockingMessage';
export const buttonStyles = {
    button: {
        marginRight: 24,
        marginLeft: 24,
    },
};
export const middleButtonStyles = Object.assign(Object.assign({}, buttonStyles), { icon: {
        height: 72,
        width: 72,
    } });
//# sourceMappingURL=index.js.map